export default __webpack_public_path__ + "static/media/matcha.605e5205.gif";